import script from "./FormularioLGPD.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioLGPD.vue?vue&type=script&setup=true&lang=js"

import "./FormularioLGPD.vue?vue&type=style&index=0&id=474a51ad&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474a51ad"]])

export default __exports__